export default __webpack_public_path__ + "static/media/el_regionaalarengu_fond_horisontaalne.f8bd138e.png";